import React, { useState, createContext } from "react"

export const MediaPopUpContext = createContext()

export const MediaPopUpProvider = ({ children }) => {
  const [popUpData, setpopUpData] = useState({
    visibility: "hidden",
    content: null,
  })
  return (
    <>
      <MediaPopUpContext.Provider value={[popUpData, setpopUpData]}>
        {children}
      </MediaPopUpContext.Provider>
    </>
  )
}
